import { ref, onMounted, Ref } from 'vue'
import { testVpn } from '@/libs/api/api'
import { secondsToMilliseconds } from '@/libs/date/date'

export const VPN_INSTRUCTIONS_URL =
  'https://app.gitbook.com/o/-MbN892xoO-71tzzZ9Yf/s/-MkCyG1YxEnT-aLhAhNp/tailscale-vpn'

/**
 *
 */
export function setup() {
  const showTroubleshooting = ref(false)
  const canHitVpn: Ref<undefined | boolean> = ref(undefined)
  const SECONDS_TO_SHOW_TROUBLESHOOTING = 5

  const handleTroubleshooting = async () => {
    showTroubleshooting.value = true
    canHitVpn.value = await testVpn()
  }
  onMounted(() => {
    setTimeout(async () => {
      void handleTroubleshooting()
    }, secondsToMilliseconds(SECONDS_TO_SHOW_TROUBLESHOOTING))
  })

  return {
    showTroubleshooting,
    canHitVpn,
    VPN_INSTRUCTIONS_URL,
  }
}
